const ROUTE_TYPE = 'trafiki:route_type'
const DASHBOARD = 'trafiki:dashboard'
const TERMINAL_IDS = 'trafiki:terminal_ids'

const saveRouteType = (routeType) => {
    if (window.localStorage) {
        localStorage.setItem(ROUTE_TYPE, routeType)
    }
}

const getRouteType = () => {
    if (window.localStorage) {
        return localStorage.getItem(ROUTE_TYPE)
    }
    return null
}

const saveDashboard = (dashboard) => {
    if (window.localStorage) {
        localStorage.setItem(DASHBOARD, dashboard)
    }
}

const getDashboard = () => {
    if (window.localStorage) {
        return localStorage.getItem(DASHBOARD)
    }
    return null
}

const saveTerminalIds = (terminalIds) => {
    if (window.localStorage) {
        localStorage.setItem(TERMINAL_IDS, terminalIds)
    }
}

const getTerminalIds = () => {
    if (window.localStorage) {
        const value = localStorage.getItem(TERMINAL_IDS)
        if (!value) {
            return []
        }
        return value.split(',').map((id) => parseInt(id, 10))
    }
    return []
}

export default {
    saveRouteType,
    getRouteType,
    saveTerminalIds,
    getTerminalIds,
    saveDashboard,
    getDashboard,
}
